// src/services/integrationHealthCache.js
//
// Slice U6 — in-memory client cache for the two Data Health reads
// (GET /api/integrations/health, GET /api/sync-events). 60-second TTL —
// shorter than the 5-min reports/leasesPortfolio caches because this
// is a "live status" surface where staleness is more visible than for
// portfolio aggregates.
//
// Sync-events results vary by filter, so the key for that read is
// composed by the client (`keyFor` mirrors the server-side helper).
// Hooked into services/cacheBus.js so every portfolio write also
// busts these keys — defensive, since a write to a portfolio entity
// shouldn't normally affect integration telemetry, but keeping the
// invariant uniform avoids surprises later when ingest jobs land.

const TTL_MS = 60 * 1000;

/** @type {Map<string, { value: any, expiresAt: number }>} */
const store = new Map();

export function get(key) {
  const entry = store.get(key);
  if (!entry) return undefined;
  if (Date.now() >= entry.expiresAt) {
    store.delete(key);
    return undefined;
  }
  return entry.value;
}

export function set(key, value) {
  store.set(key, { value, expiresAt: Date.now() + TTL_MS });
}

export function invalidateAll() {
  store.clear();
}

export function keyFor(prefix, params = {}) {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
    .map(([k, v]) => `${k}=${String(v)}`);
  return parts.length === 0 ? prefix : `${prefix}?${parts.join("&")}`;
}

export const KEY_INTEGRATIONS_HEALTH = "integrations-health";
export const KEY_PREFIX_SYNC_EVENTS  = "sync-events";

export function __resetForTests() { store.clear(); }
export function __sizeForTests()  { return store.size; }
export const TTL_MS_FOR_TESTS = TTL_MS;
